import app from './Vue/app';
import StickFlip from '@components/products/StickFlip.vue';
import NotesView from '@components/products/NotesView.vue';
import VideoPlayer from '@components/VideoPlayer.vue';

app.component('StickFlip', StickFlip);
app.component('NotesView', NotesView);
app.component('VideoPlayer', VideoPlayer);
